import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-title\"><div>Funding Statistic</div><div><span class=\"badge badge-primary ms-3 me-3\"> Deposit </span><span class=\"badge badge-warning me-3 text-black\"> Withdraw </span><span class=\"badge badge-success me-3\"> Positive Net </span><span class=\"badge badge-danger me-3\"> Negative Net </span><span class=\"badge badge-secondary me-3\"> Rebate </span></div></div>", 1)
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "d-flex gap-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-3" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "card-body"
}

import { watch, onMounted, ref } from "vue";
import AccountStat from "./AccountStat.vue";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetailStat',
  props: {
    accountDetails: {}
  },
  setup(__props: any) {

const props = __props;

const period = ref([] as any);
const refresh = ref(true);
const accountStatRef = ref<InstanceType<typeof AccountStat>>();


const criteria = ref<any>({
  uid: props.accountDetails.uid,
  from: "",
  to: "",
  viewClient: false,
});

const defaultTime = ref<[Date, Date]>([
  new Date(2000, 1, 1, 0, 0, 0),
  new Date(2000, 2, 1, 23, 59, 59),
]);

const confirmSearch = () => {
  refresh.value = false;
  setTimeout(() => {
    refresh.value = true;
  }, 100);
};

const clearSearchFilterCriteria = () => {
  criteria.value = { from: "", to: "", viewClient: false };
  period.value = [];
  refresh.value = false;
  setTimeout(() => {
    refresh.value = true;
  }, 100);
};

onMounted(() => {
  console.log("mounted: accountDetails");
});

watch(
  () => period.value,
  (periodVal) => {
    if (periodVal && periodVal.length > 0 && typeof periodVal[0] !== "string") {
      periodVal = [
        moment(periodVal[0]).local().toISOString(),
        moment(periodVal[1]).local().toISOString(),
      ];
    }
    criteria.value.from = periodVal ? periodVal[0] : null;
    criteria.value.to = periodVal ? periodVal[1] : null;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_date_picker, {
                class: "w-250px",
                modelValue: period.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
                type: "daterange",
                "start-placeholder": _ctx.$t('fields.startDate'),
                "end-placeholder": _ctx.$t('fields.endDate'),
                "default-time": defaultTime.value
              }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "default-time"]),
              _createVNode(_component_el_button, {
                plain: "",
                type: "primary",
                onClick: confirmSearch
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                plain: "",
                type: "info",
                onClick: clearSearchFilterCriteria
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
                ]),
                _: 1
              })
            ]),
            _hoisted_6
          ])
        ])
      ]),
      (refresh.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(AccountStat, {
              ref_key: "accountStatRef",
              ref: accountStatRef,
              uid: _ctx.$props.accountDetails.uid,
              from: criteria.value.from,
              to: criteria.value.to,
              viewClient: criteria.value.viewClient
            }, null, 8, ["uid", "from", "to", "viewClient"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})